import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { IoMdCloudUpload } from "react-icons/io";
import { AiOutlineDelete } from "react-icons/ai";
import BackButton from "../CommonComponents/BackButton";
import "../../index.css";
import { useQuery, gql, useMutation } from "@apollo/client";
import LabledInput from "../CommonComponents/LabledInput";
import CustomSelect from "../CommonComponents/CustomSelect";
import CustomSwitch from "../CommonComponents/CustomSwitch";

const ADD_EMPLOYEE = gql`
  mutation addEmployee($data: employeeInput!) {
    addEmployee(data: $data) {
      status
      message
    }
  }
`;

const AddEmployeeForm = ({ setAddEmployee }) => {
  const [fullName, setName] = useState("");
  const [contactNumber, setContactNumber] = useState("");
  const [email, setEmail] = useState("");
  const [inventoryList, setInventoryList] = useState([{ inventoryId: "" }]);
  const [isFetched, setIsFetched] = useState(true);
  const [dataList, setDataList] = useState([]);
  const [address, setAddress] = useState("");
  const [radius, setRadius] = useState(null);
  const [assignedGender, setAssignedGender] = useState("");
  const [salaryType, setSalaryType] = useState("MONTHLY");
  const [commissionPercentage, setCommissionPercentage] = useState(10);
  const [perDaySalary, setPerDaySalary] = useState(0);
  const [monthlySalary, setMonthlySalary] = useState(0);
  const [isDummy, setIsDummy] = useState(false);
  const [notifyAdmin, setNotifyAdmin] = useState(false);
  const [addEmployee, { addLoading, addError }] = useMutation(ADD_EMPLOYEE);
  // const [govtIdImage, setGovtIdImage] = useState("");
  // const [vehicleIdImage, setVehicleIdImage] = useState("");
  // const [LicenseImage, setLicenseImage] = useState("");
  // const govtId = useRef(null);
  // const vehicleId = useRef(null);
  // const license = useRef(null);
  // const [baseLat, setBaseLat] = useState("");
  // const [baseLong, setBaseLong] = useState("");
  // const [flatNo, setFlatNumber] = useState("");

  // const [mutationHandler, { data, loading }] = useMutation(YOUR_MUTATION, {
  //   onError: (err) => {
  //       setError(err);
  //   }
  // });

  // const handleGovtIdUpload = async (e) => {
  //   const file = e.target.files[0];
  //   // console.log(file.file);
  //   // setGovtIdImage(file);
  //   e.preventDefault();
  //   const url = `https://api.barbera.in/img/upload`;
  //   try {
  //     const formData = new FormData();

  //     formData.append("file", file);

  //     const { data } = await axios.post(url, formData);
  //     console.log(data);
  //     if (data.status === "Success") {
  //       setGovtIdImage(data.url);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     window.alert(error.message + " Try Again");
  //     // history.push("/dashboard/compliance");
  //   }
  // };

  // const handleBrowseGovtIdClick = () => {
  //   govtId.current.click();
  // };

  // const handleVehicleIdUpload = async (e) => {
  //   const file = e.target.files[0];
  //   // setVehicleIdImage(file);
  //   e.preventDefault();
  //   const url = `https://api.barbera.in/img/upload`;
  //   try {
  //     const formData = new FormData();

  //     formData.append("file", file);

  //     const { data } = await axios.post(url, formData);
  //     console.log(data);
  //     if (data.status === "Success") {
  //       setVehicleIdImage(data.url);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     window.alert(error.message + " Try Again");
  //     // history.push("/dashboard/compliance");
  //   }
  // };

  // const handleBrowseVehicleIdClick = () => {
  //   vehicleId.current.click();
  // };

  // const handleLicenseUpload = async (e) => {
  //   const file = e.target.files[0];
  //   // setLicenseImage(file);
  //   e.preventDefault();
  //   const url = `https://api.barbera.in/img/upload`;
  //   try {
  //     const formData = new FormData();

  //     formData.append("file", file);

  //     const { data } = await axios.post(url, formData);
  //     console.log(data);
  //     if (data.status === "Success") {
  //       setLicenseImage(data.url);
  //     }
  //   } catch (error) {
  //     console.error(error);
  //     window.alert(error.message + " Try Again");
  //     // history.push("/dashboard/compliance");
  //   }
  // };

  // const handleBrowseLicenseClick = () => {
  //   license.current.click();
  // };

  const handleAdd = (e) => {
    e.preventDefault();
    let finalDataObj = {};
    finalDataObj.fullName = fullName;
    finalDataObj.contactNumber = contactNumber;
    finalDataObj.email = email;
    // finalDataObj.governmentId = govtIdImage;
    // finalDataObj.vehicleId = vehicleIdImage;
    // finalDataObj.license = LicenseImage;
    finalDataObj.gender = assignedGender;
    // finalDataObj.baseLat = baseLat;
    // finalDataObj.baseLong = baseLong;
    finalDataObj.address = address;
    finalDataObj.radius = radius;
    finalDataObj.salaryType = salaryType;
    finalDataObj.commissionPercentage = Number(commissionPercentage);
    finalDataObj.perDaySalary = Number(perDaySalary);
    finalDataObj.monthlySalary = Number(monthlySalary);
    finalDataObj.isDummy = isDummy;
    finalDataObj.notifyAdmin = notifyAdmin;
    // finalDataObj.flatNo = flatNo;
    console.log(finalDataObj);

    // addEmployee({
    //   variables:{
    //     data: fullName,
    //     contactNumber: contactNumber,
    //     inventoryList:[
    //       {
    //         inventoryId: "263491cd-bc98-4348-9b8e-deec5af1dd64",
    //         price:60
    //       },
    //       {
    //         inventoryId: "e8d66dfc-9f68-43e3-ae9b-5eb840b9c012",
    //         price: 40
    //       }
    //     ]
    //   }
    // }).then((res)=>{
    //   console.log('res is');
    //   // console.log(res);
    //   // if(res.data.addBanner.status === "SUCCESS"){
    //   //   window.location.reload();
    //   // }
    // }).catch(err=>{
    //   console.log(err);
    // })

    //================================

    addEmployee({
      variables: {
        data: finalDataObj,
      },
    })
      .then((res) => {
        if (res.data.addEmployee.status === "SUCCESS") {
          window.location.reload();
        }
      })
      .catch((err) => {
        console.log(err);
      });
    // setAddEmployee(false);
  };

  const handleInventoryChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = value;
    setInventoryList(updatedList);
  };

  const handleInventoryPriceChange = (index, event) => {
    const { name, value } = event.target;
    const updatedList = [...inventoryList];
    updatedList[index][name] = parseInt(value);
    setInventoryList(updatedList);
  };

  const handleRemoveRow = (index) => {
    const updatedList = [...inventoryList];
    updatedList.splice(index, 1);
    setInventoryList(updatedList);
  };

  const handleAddRow = () => {
    setInventoryList([...inventoryList, { inventoryId: "" }]);
  };

  return (
    isFetched && (
      <div className="flex flex-col space-y-10">
        <BackButton onClick={() => setAddEmployee(false)} />

        <h3 className="font-be-jost-pro font-bold text-2xl text-[#FBB033]">
          Add Employee
        </h3>

        <LabledInput
          placeholder="Type name here*"
          value={fullName}
          onChange={(e) => setName(e.target.value)}
          label={"Name"}
        />

        <LabledInput
          value={contactNumber}
          onChange={(e) => setContactNumber(e.target.value)}
          label={"Contact"}
          placeholder={"Type contact number"}
          specialLabel={"+91"}
        />

        <LabledInput
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          label={"Email"}
          placeholder={"Type email address..."}
        />

        <CustomSelect
          label="Gender"
          placeholder="Select Gender"
          value={assignedGender}
          onChange={(e) => setAssignedGender(e.target.value)}
          options={["Male", "Female"]}
          required={true} // not mandatory now
          inline
          showReset // ✅ enables Reset button
        />

        <LabledInput
          value={address}
          onChange={(e) => setAddress(e.target.value)}
          label={"Address"}
          placeholder={"Type base address here..."}
        />
        <LabledInput
          value={radius}
          onChange={(e) => setRadius(Number(e.target.value))}
          label={"Radius"}
          placeholder={"Type radius..."}
        />

        <CustomSelect
          label="Salary Type"
          placeholder="Select Salary Type"
          value={salaryType}
          onChange={(e) => setSalaryType(e.target.value)}
          options={["MONTHLY", "MONTHLY_PLUS_COMMISSION", "PER_DAY", "PER_DAY_PLUS_COMMISSION"]}
          required={true}
          inline
        />

        {(salaryType === "MONTHLY" || salaryType === "MONTHLY_PLUS_COMMISSION") && (
          <LabledInput
            value={monthlySalary}
            onChange={(e) => setMonthlySalary(Number(e.target.value))}
            label={"Monthly Salary"}
            placeholder={"Type monthly salary..."}
          />
        )}

        {(salaryType === "PER_DAY" || salaryType === "PER_DAY_PLUS_COMMISSION") && (
          <LabledInput
            value={perDaySalary}
            onChange={(e) => setPerDaySalary(Number(e.target.value))}
            label={"Per Day Salary"}
            placeholder={"Type per day salary..."}
          />
        )}

        {(salaryType.includes("COMMISSION")) && (
          <LabledInput
            value={commissionPercentage}
            onChange={(e) => setCommissionPercentage(Number(e.target.value))}
            label={"Commission %"}
            placeholder={"Type commission percentage..."}
          />
        )}

        <CustomSwitch
          id="isDummy"
          label="Dummy Employee"
          checked={isDummy}
          onChange={(checked) => setIsDummy(checked)}
        />

        <CustomSwitch
          id="notifyAdmin"
          label="Notify Admin on Booking"
          checked={notifyAdmin}
          onChange={(checked) => setNotifyAdmin(checked)}
        />

        {
          // inventoryList.map((inventory, index) => {
          //   return (
          //     <div className="flex space-x-2 lg:space-x-8" key={index}>
          //       <select
          //         className={`px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none ${
          //           inventory.inventoryId === ""
          //             ? " text-[#9A9A9A]"
          //             : "text-white"
          //         } w-1/2 lg:w-[25%]`}
          //         value={inventory.inventoryId}
          //         onChange={(e) => handleInventoryChange(index, e)}
          //         name="inventoryId"
          //       >
          //         <option value="" disabled hidden>
          //           Inventory*
          //         </option>
          //         {/* <option value="Hair Cutting Kit">Hair Cutting Kit</option>
          //     <option value="Hair Color Kit">Hair Color Kit</option> */}
          //         {dataList.map((item, i) => (
          //           <option value={item.id} key={i}>
          //             {item.name}
          //           </option>
          //         ))}
          //       </select>
          //       <div className="flex items-center">
          //         <span
          //           className="text-[#FBB033] font-be-jost-pro text-base font-normal cursor-pointer"
          //           onClick={handleAddRow}
          //         >
          //           {`Add Inventory +  `}
          //         </span>
          //         {inventoryList.length !== 1 && (
          //           <AiOutlineDelete
          //             className="text-[#FBB033] text-2xl cursor-pointer"
          //             onClick={() => handleRemoveRow(index)}
          //           />
          //         )}
          //       </div>
          //     </div>
          //   );
          // })
        }
        {/* <div className="flex flex-col lg:flex-row space-y-10 lg:space-y-0 w-full lg:items-center lg:w-4/5">
          <div className="flex items-center w-full lg:w-1/2">
            <input
              id="govt-id"
              type="file"
              ref={govtId}
              className="hidden"
              onChange={handleGovtIdUpload}
            />
            <input
              type="text"
              placeholder="Government Id*"
              disabled={true}
              className="w-1/2 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
            />
            <p className="ml-3 mr-2 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer">
              Upload ID
            </p>
            <IoMdCloudUpload
              className="text-[#FBB033] text-3xl"
              onClick={handleBrowseGovtIdClick}
            />
          </div>
          <div className="flex items-center w-full lg:w-1/2">
            <input
              id="vehicle-id"
              type="file"
              ref={vehicleId}
              className="hidden"
              onChange={handleVehicleIdUpload}
            />
            <input
              type="text"
              placeholder="Vehicle Id*"
              disabled={true}
              className="w-1/2 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
            />
            <p className="ml-3 mr-2 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer">
              Upload ID
            </p>
            <IoMdCloudUpload
              className="text-[#FBB033] text-3xl"
              onClick={handleBrowseVehicleIdClick}
            />
          </div>
        </div> */}

        {/* <div className="flex items-center">
          <input
            id="license"
            type="file"
            ref={license}
            className="hidden"
            onChange={handleLicenseUpload}
          />
          <input
            type="text"
            placeholder="License*"
            disabled={true}
            className="w-3/5 lg:w-1/5 px-2 py-1 bg-[#0c0b0b] border-b-[1px] border-b-[#E0E0E0] outline-none text-white"
          />
          <p className="ml-3 mr-2 font-be-jost-pro text-[#FBB033] font-normal text-base cursor-pointer">
            Upload ID
          </p>
          <IoMdCloudUpload
            className="text-[#FBB033] text-3xl"
            onClick={handleBrowseLicenseClick}
          />
        </div> */}

        <div className="flex py-16 w-full justify-center items-center">
          <button
            className="px-5 py-2 bg-[#FBB034] font-poppins text-sm font-bold rounded-md"
            onClick={handleAdd}
          >
            Add Employee
          </button>
        </div>
      </div>
    )
  );
};

export default AddEmployeeForm;
